<template>
  <payouts-list
    @loadData="loadData($event)"
    :loading-payouts="payoutsLoading"
    :payouts="payouts"
    :payoutsLoading="payoutsLoading"
    :selectedLanguage="selectedLanguage"
    :totalPayouts="totalCount"
    :currencySymbol="currencySymbol"

    @loadChargesForPayout="loadDataForCharges($event)"
    :charges="charges"
    :chargesLoading="chargesLoading"
    :totalCharges="totalChargesCount"

    @downloadChargeReport="downloadChargeReport($event)"
    @downloadPayoutReport="downloadPayoutReport($event)"
    :reportGenerating="reportGenerating"
  ></payouts-list>
</template>

<script>
import dayjs from '../../plugins/dayjs';
import PayoutsList from '../../components/PayoutsList.vue';
import { listPayouts, listChargesForPayout } from '../../mixins/payouts.mixins';
import { languageMethods, languageComputed } from '../../mixins/language.mixins';
import { bookingChannelComputed } from '../../mixins/bookingChannel.mixins';
import { csvReport } from '../../mixins/csvReport.mixins';
import { download } from '../../mixins/download.mixins';

export default {
  name: 'list-payouts-view',
  components: { PayoutsList },
  mixins: [
    bookingChannelComputed,
    listPayouts,
    listChargesForPayout,
    languageMethods,
    languageComputed,
    csvReport,
    download,
  ],
  computed: {
    totalCount() {
      return this.payoutsListInfo.totalCount;
    },
    totalChargesCount() {
      return this.chargesListInfo.totalCount;
    },
  },
  methods: {
    async loadDataForCharges({
      sort, page, maxPerPage, payoutId,
    }) {
      this.chargesSearchObject = {
        page,
        maxPerPage,
        sort,
        payoutId,
      };
      await this.listChargesForPayout();
    },
    async loadData({
      sort, page, maxPerPage, statusAtStart, statusAtEnd, status,
    }) {
      this.payoutsSearchObject = {
        page,
        maxPerPage,
        sort,
        statusAtStart,
        statusAtEnd,
        status,
      };
      await this.listPayouts();
    },

    async downloadChargeReport({ sort, payoutId }) {
      const filename = `${this.$t(
        'pages.payouts.dialog.filenamePrefix', { payoutId }
      )}-${dayjs().format('YYYY-MM-DD_HHmmss')}.csv`;
      this.reportCaptureGenerationObject = {
        filename,
        sort,
        payoutId,
        timezone: 'local',
      };

      const result = await this.generateCaptureReport();

      if (!result.errorCode) {
        this.download({ data: this.reportData, filename });
      }
    },

    async downloadPayoutReport({ sort, statusAtStart, statusAtEnd }) {
      const filename = `${this.$t(
        'pages.payouts.list.filenamePrefix',
      )}-${dayjs().format('YYYY-MM-DD_HHmmss')}.csv`;
      this.reportPayoutGenerationObject = {
        filename,
        sort,
        statusAtStart,
        statusAtEnd,
        status: 'paid',
      };

      const result = await this.generatePayoutReport();

      if (!result.errorCode) {
        this.download({ data: this.reportData, filename });
      }
    },
  },
};
</script>
